module.exports = __webpack_public_path__ + "img/industryScore3.994bc335.png";